function l(r) {
  var e = {
    called: !1
  };
  return function () {
    if (!e.called) return e.called = !0, r.apply(void 0, arguments);
  };
}
export { l as once };